import { susIcons } from 'config/services/requests'
import { FC, useState, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ReactComponent as LogoIcon } from 'assets/icons/sustamize_Logo.svg'

interface iPackageOfferingFeaturesProps {
  features: string
  descriptionHeading?: string
  description?: string
  isMultipleColumns?: boolean
}

export const PackageOfferingFeatures: FC<iPackageOfferingFeaturesProps> = ({
  features,
  descriptionHeading,
  description,
  isMultipleColumns = false,
}) => {
  const [_features, setFeatures] = useState<string[]>([])
  const { t } = useTranslation()
  const renderFeature = (i: number, i18nKey: string) => {
    return (
      <div
        className={`group/feature relative flex 
        ${isMultipleColumns ? 'w-1/2' : 'w-full'}
      `}
        key={i}
      >
        <div
          className={`
          flex items-center justify-center gap-2 text-xs py-2 w-full
          ${
            !isMultipleColumns
              ? 'lg:border-b border-b-gray-300 dark:border-b-gray-700 group-last/feature:border-0'
              : ''
          }
        `}
        >
          <LogoIcon className="w-5 h-5 flex-shrink-0" />
          <span className="text-left">
            <Trans i18nKey={i18nKey} />
          </span>
        </div>
      </div>
    )
  }

  useEffect(() => {
    const numOfFeaturesGuess = Array.from(Array(30).keys())
    const featuresSet: string[] = []

    const isEndsWithGuess = (key: string): boolean => {
      const str = t(key)
      return /\d+$/.test(str)
    }

    numOfFeaturesGuess.forEach((i) => {
      const i18nKey = `${features}.${i}`
      const endsWithGuess = isEndsWithGuess(i18nKey)
      if (endsWithGuess) return null

      featuresSet.push(i18nKey)
    })

    setFeatures([])
    setFeatures(featuresSet)
  }, [features, t])

  return (
    <div className={`w-full`}>
      {descriptionHeading && t(descriptionHeading) !== '' && (
        <div
          className={`
          ${_features.length === 0 ? 'my-6' : 'mb-2 pt-3 font-bold text-xs'}
          text-center
          font-bold
        `}
        >
          {t(descriptionHeading)}
        </div>
      )}
      {description && t(description) !== '' && (
        <div className={`text-xs pt-2 mb-3 pl-1.5 w-full text-center`}>
          {description && t(description)}
        </div>
      )}

      <div
        className={`flex ${
          isMultipleColumns ? 'flex-row flex-wrap' : 'flex-col'
        } lg:flex-row lg:flex-wrap flex-grow-0 flex-shrink basis-auto text-center`}
      >
        {_features.length > 0 ? (
          _features.map((f, i) => renderFeature(i, f))
        ) : !descriptionHeading ? (
          <div className="w-full py-2 opacity-0">
            <div className="flex items-center justify-center gap-2 text-xs">
              <LogoIcon className="w-5 h-5" />
              <span>Placeholder</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
